export default "__VITE_ASSET__DtHGahqA__"